"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9887],{

/***/ 89887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pro_tools_Screener; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/LandingPage/index.ts + 8 modules
var LandingPage = __webpack_require__(55781);
// EXTERNAL MODULE: ./src/features/pro-tools/constants.ts
var constants = __webpack_require__(23443);
;// CONCATENATED MODULE: ./src/features/pro-tools/Screener/content.ts
var screenerContents = [
    {
        title: "Guru Screener",
        description: "Saring saham sesuai dengan kriteria guru investasi dunia seperti Warren Buffett, Peter Lynch, Piotroski dan lainnya.",
        image: "Screener_Guru_Screener_Blue.jpg"
    },
    {
        title: "100+ Financial Metrics",
        description: "Manfaatkan database data keuangan kami yang luas untuk mencari dan memilah saham sesuai dengan kriteria yang dinginkan secara cepat dan tepat.",
        image: "Screener_Financial_Metrics_Blue.jpg"
    },
    {
        title: "Preset Screener",
        description: "Preset screener siap pakai yang berisi screener yang biasa digunakan oleh investor profesional seperti screneer untuk saham yang memiliki PE Strong Undervalued atau screener saham High Volume Breakout.",
        image: "Screener_Preset_Screener_Blue.jpg"
    },
    {
        title: "Ratio vs Ratio",
        description: "Gunakan perbandingan dua rasio berbeda sebagai kriteria dari screener buatanmu.",
        image: "Screener_Ratio_Blue.jpg"
    }, 
];
/* harmony default export */ var content = (screenerContents);

;// CONCATENATED MODULE: ./src/features/pro-tools/Screener/index.tsx




function Screener() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPage/* PageHeader */.mr, {
                title: "Screener",
                description: "Saring saham dari perusahaan berkualitas dengan mudah"
            }),
            content.map(function(content, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPage/* SectionBrowser */.Dr, {
                    title: content.title,
                    image: "".concat(constants/* ASSET_URL */.Z).concat(content.image),
                    description: content.description,
                    reverse: index % 2 === 0
                });
            })
        ]
    });
}
/* harmony default export */ var pro_tools_Screener = (Screener);


/***/ })

}]);